import React, { useState, useEffect } from 'react';
import api from '../../services/api';
import Header from '../../components/Header';
import Footer from '../../components/Footer';
import { Row, Input, Table, Col, Popconfirm } from 'antd';
import { Form, Button, Select, Space, message } from 'antd';
import ModalModulo from '../../components/ModalModulo';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import * as ModalStatusAction from '../../redux/actions/modalStatus'
import * as PermissaoAction from '../../redux/actions/permissao'

interface ModuloProps {
    modalStatus?: any,
    setNovoModuloModal: any,
    setEditarModuloModal: any,
    permissao?:any,
    setPermissaoAcesso:any
}

const Modulo: React.FC<ModuloProps> = (props) => {

    const [Modulos, setModulos] = useState([]);
    const [loading, setLoading] = useState(false);   
    const [form] = Form.useForm();

    useEffect(() => {       
       
        if (props.modalStatus[0].visibleNovoModulo === false ||
            props.modalStatus[0].visibleEditarModulo === false) {
            getModulos();
        }

    }, [props.modalStatus[0]])
    



    const novoModulo = async (values: any) => {

        if (props.permissao[0].permissaoAcesso?.cadastrar === false) {
            message.warn("Usuário não possui permissão de cadastro");
            return;
        }
        props.setNovoModuloModal(true);

    }

    const editarModulo = (values: any) => {

        if (props.permissao[0].permissaoAcesso?.editar === false) {
            message.warn("Usuário não possui permissão de edição");
            return;
        }

        props.setEditarModuloModal(true, values)
    }


    const excluirModulo = async (id: any) => {


        setLoading(true);
        await api.delete(`Modulo?id=${id}`).then(response => {

            message.success('Modulo excluído com sucesso!');
            api.get(`Modulo/porperfil?perfilID=${sessionStorage.getItem('grupoID')}`).then((response) => {
                sessionStorage.setItem('modulos', JSON.stringify(response.data));
            })
        }).catch(() => {
            message.error('Falha na requisição');
        }).finally(() => {
            getModulos();
            setLoading(false);
        })
    }

    const getModulos = async () => {
        await api.get('Modulo')
            .then(response => {
                setModulos(response.data);
            })
            .catch(response => {
                message.error('Falha na requisição');
            })

    }

    const columns = [
        { title: "Nome", dataIndex: "nome", key: "nome", width: 300 },
        { title: "URL", dataIndex: "navegarURL", key: "url", width: 300 },
        {
            title: "Status", dataIndex: "ativo", key: "status",
            render: (record: any) => (
                <p>{record ? 'ativo' : 'inativo'}</p>
            ),
            width: 200
        },
        {
            title: "Possui Menu", dataIndex: "possuiMenu", key: "possuiMenu",
            render: (record: any) => (
                <p>{record ? 'Sim' : 'Não'}</p>
            ),
            width: 200
        },

        {
            title: 'Ações',
            key: 'action',
            render: (record: any) => (
                <Space size="middle">
                    {props.permissao[0].permissaoAcesso?.editar ?
                        <Button htmlType="button" onClick={() => editarModulo(record)}>Editar</Button>
                        : null}
                    {props.permissao[0].permissaoAcesso?.excluir ?
                        <Popconfirm key={record.moduloID} placement="top" title="Você tem certeza que deseja excluir esse modulo?" onConfirm={() => { excluirModulo(record.moduloID); }} okText="Sim" cancelText="Não">
                            <Button type="primary" key={record.moduloID} danger >  Excluir </Button>
                        </Popconfirm>
                        : null
                    }
                </Space>
            ),
            fixed: 'right' as 'right',
            width: 200
        }]

    const pesquisar = () => {
        let filtros = form.getFieldsValue();

        let newParams = {
            'nome': filtros.nome ? filtros.nome : undefined,
            'ativo': filtros.ativo ? filtros.ativo : undefined,
        }
        api.get('Modulo/comfiltros', { params: newParams })
            .then(response => {
                setModulos(response.data);
            })
            .catch(response => {
                message.error('Falha na requisição');
            })
    }   

    return (
        <>
            <Header />
            <br />
            <div className="container NoneUpperCase">
                <fieldset className="fieldset-consulta">
                    <Form
                        form={form}
                        labelCol={{ span: 24 }} wrapperCol={{ span: 24 }}
                        layout="horizontal"
                        size="middle"
                    >
                        <Row gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }}>
                            <Col className="gutter-row" span={12}>

                                <Form.Item name="nome" label="Nome">
                                    <Input placeholder="Digite o nome do Módulo" />
                                </Form.Item>
                            </Col>
                            <Col className="gutter-row" span={12}>
                                <Form.Item name="ativo" label="Status">
                                    <Select placeholder="Selecione">
                                        <Select.Option value="0"> Selecione </Select.Option>
                                        <Select.Option value="1"> Ativo </Select.Option>
                                        <Select.Option value="2"> Inativo </Select.Option>
                                    </Select>
                                </Form.Item>
                            </Col>
                            {/* <Col className="gutter-row" span={6}>
                                <Form.Item label="Ícone" name="icone" >
                                    <Select placeholder="Selecione">
                                        <Select.Option value="0"> Selecione </Select.Option>
                                        <Select.Option value="1"> Ativo </Select.Option>
                                        <Select.Option value="2"> Inativo </Select.Option>
                                    </Select>
                                </Form.Item>
                            </Col> */}
                        </Row>
                        <Row>
                            <Col>
                                <Form.Item>
                                    {props.permissao[0].permissaoAcesso?.cadastrar ?
                                        <Button type="ghost" htmlType="button" onClick={novoModulo}>Novo Módulo</Button>
                                        : null
                                    }
                                </Form.Item>
                            </Col>
                            <Col>
                                <Form.Item>
                                    <Button onClick={pesquisar} className="button-filtrar" type="primary" htmlType="submit">
                                        Filtrar
                                </Button>
                                </Form.Item>
                            </Col>
                        </Row>
                    </Form>
                </fieldset>
                <br />
                <Row>
                    <Col className="gutter-row" span={24}>
                        <Table
                            className="ant-table-var-local"
                            columns={columns}
                            dataSource={Modulos}
                            scroll={{ x: 900 }}
                            rowKey={"moduloID"}
                            bordered={true}>

                        </Table>
                    </Col>
                </Row>
            </div>
            <ModalModulo />
            <Footer />
        </>);
}


const mapStateToProps = (state: any) => ({
    modalStatus: state.modalStatus,
    permissao: state.permissao
})

const mapDispatcToProps = (dispatch: any) => 
{     
    return  bindActionCreators(Object.assign({},PermissaoAction, ModalStatusAction), dispatch);    
}

export default connect(mapStateToProps, mapDispatcToProps)(Modulo);